import thinkingdata from "thinkingdata-browser";

const config = {
  serverUrl:'https://ta-collector.centurygame.com/sync_js', //数据上传的URL
  autoTrack: {
   pageShow: true, //开启页面展示事件，事件名ta_page_show
   pageHide: true, //开启页面隐藏事件，事件名ta_page_hide
  }
};

class Tracker{
  constructor() {
    this.ta = thinkingdata
  }
  install = (Vue, option) => {
    this.init(Vue, option)
    this.registerDirective(Vue, option)
  }

  init = (Vue, option) => {
    if (!option.appId) {
      throw new Error('请设置appid')
    }
    this.ta.init({
      ...config,
      ...option
    });
    Vue.prototype.$ta = this.ta
    this.ta.setSuperProperties({
      createtime: Date.now(),
    })
  }

  /**
   * 使用示例：
   *  <img
   *   v-track:click|exposure
   *   track-event="offsite_enter"
   *   track-data-name="qzx"
   *   track-data-age="16"
   *   src="@/assets/images/googleBadge.png" alt=""
   *  >
   */
  registerDirective = (Vue, option) => {
    const _this = this
    Vue.directive('track', {
      bind (el, binding, vnode, oldVnode) {
        // 获取指令参数
        const { arg } = binding
        // 埋点名称
        const event = el.getAttribute("track-event").trim()
        // 埋点参数截取
        const data = {}
        for(let name of el.getAttributeNames()) {
          if (name.indexOf('track-data-') > -1) {
            data[name.substring(11)] = el.getAttribute(name)
          }
        }
        // 埋点上报方式处理，目前方式：点击、曝光（进入可视区域window）
        arg.split("|").forEach((item) => {
          if (item.trim() === "click") {
            el.addEventListener('click', () => {
              _this.track(event, data)
            })
          } else if (item.trim() === "exposure") {
            const io = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  io.unobserve(el)
                  _this.track(event, data)
                }
              })
            }, {
              root: null,
              rootMargin: "0px",
              threshold: [0],
            })
            io.observe(el)
          }
        })
      }
    })
  }

  track = (event, data) => {
    this.ta.track(event, data)
  }
}

export default new Tracker()



// WEBPACK FOOTER //
// ./src/tool/ta.js